import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import { fetchFirms } from '../../../services/firms';
import * as actions from '../firmsActions';
import { errorOpenModal } from '../../_shared/modal/errorModalActions';

export default function* fetchFirmsWatcher() {
  yield takeLatest(actions.FETCH, fetchFirmsWorker);
}

export function* fetchFirmsWorker(action) {
  yield put(actions.loading(true));
  const { sortColumn, sortDirection, rowsPerPage, page, filterObject } = action.pageDetails;

  const variables = {
    /* MUI pagination is 0-indexed; API expects 1-indexed page number. */
    page: page + 1,
    limit: rowsPerPage,
    field: sortColumn,
    direction: sortDirection,
    FirmName: filterObject.FirmName,
  };
  try {
    const response = yield call(fetchFirms, variables);
    yield call(success, response);
  } catch (error) {
    yield call(failure, error);
  }
}

export function* success(response) {
  yield put(actions.loading(false));

  const data = _.get(response, 'data.fetchFirms.Firms', []);
  const totalFirms = _.get(response, 'data.fetchFirms.FirmsCount', 0);

  yield put(actions.setData(data));
  yield put(actions.setTotalFirms(totalFirms));
}

export function* failure(error) {
  yield put(actions.loading(false));
  yield put(
    errorOpenModal({
      title: 'Failed to fetch firms',
      message: 'Unable to retrieve firms. Please try again or contact support if the issue persists.',
    }),
  );
  yield put(actions.error(error));
}
